import Text from 'components/Text/Text';
import React from 'react';
import { IModifierModifierGroups } from 'types';
import style from './ModifierGroupsScrollView.module.scss';

interface IModifierGroupsScrollView {
	data: IModifierModifierGroups[];
}

const ModifierGroupsScrollView: React.FC<IModifierGroupsScrollView> = ({ data }) => {
	return (
		<div className={style.container}>
			{data.length
				? data.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.modifierGroupName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default ModifierGroupsScrollView;
